import TweenMax from 'gsap/TweenMax';

export default function FireFighter(
  container,
  canvas,
  duration,
  beforeAnimation
) {
  const {
    top: containerTop,
    left: containerLeft,
  } = container.getBoundingClientRect();

  const { top: canvasTop, right: canvasRight } = canvas.getBoundingClientRect();

  const initialX = canvasRight - containerLeft;
  const initialY = containerTop - canvasTop + 50;
  const firefighterImage = container.getElementsByClassName('firefighter-0');
  const firefighterInitialX = 20;
  const firefighterInitialY = 20;

  beforeAnimation(initialX, initialY);

  TweenMax.set(firefighterImage, {
    x: firefighterInitialX,
    y: firefighterInitialY,
  });

  TweenMax.to(container, 0.25, {
    opacity: 1,
    onComplete() {
      TweenMax.to(firefighterImage, duration - 0.25, {
        y: firefighterInitialX + 100,
      });
    },
  });
}
